import React from 'react';
import { Col, Checkbox, Row, Body, styled } from '@teko/ds-desktop';
import { SellerCard } from '@teko/teko-ecommerce';
import { t } from '../../i18n.es.js';

const CartSeller = ({ name, imageUrl, slogan, checked = false, indeterminate = false, onCheck, isAvatarHidden = false, }) => {
    return (React.createElement(Wrapper, { justify: "space-between", align: "middle" },
        React.createElement(Col, { flex: "4%" },
            React.createElement(Checkbox, { checked: checked, partSelected: indeterminate, onChange: () => onCheck(!checked) })),
        React.createElement(Col, { flex: "96%" },
            React.createElement(Row, { justify: "space-between", align: "middle" },
                React.createElement(Col, { span: 6 },
                    React.createElement(SellerCard, { name: name, slogan: slogan, avatar: { src: imageUrl || '' }, isAvatarHidden: isAvatarHidden })),
                React.createElement(PriceColumn, { span: 2, paddingRight: "s16" },
                    React.createElement(Body, null, t('Đơn giá'))),
                React.createElement(QuantityColumn, { span: 2 },
                    React.createElement(Body, null, t('Số lượng'))),
                React.createElement(PriceColumn, { span: 2 },
                    React.createElement(Body, null, t('Thành tiền')))))));
};
const PriceColumn = styled(Col) `
  text-align: right;
`;
const QuantityColumn = styled(Col) `
  text-align: center;
`;
const Wrapper = styled(Row) `
  padding: 1rem;
  border-bottom: 1px solid #eaeaea;
`;

export { CartSeller };
